import { render, staticRenderFns } from "./CertificationInfo.vue?vue&type=template&id=0b69b242&scoped=true&"
import script from "./CertificationInfo.vue?vue&type=script&lang=js&"
export * from "./CertificationInfo.vue?vue&type=script&lang=js&"
import style0 from "./CertificationInfo.vue?vue&type=style&index=0&id=0b69b242&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b69b242",
  null
  
)

export default component.exports